export default __webpack_public_path__ + "static/media/69.add5e054.jpeg";